(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("iTZ5P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc2cc0de6109f76d$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $gBmLA = parcelRequire("gBmLA");
var $dc2cc0de6109f76d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CookieBar(param) {
        var el = param.el;
        (0, $J7ygF._)(this, CookieBar);
        this.el = el;
        this.acceptButton = this.el.querySelector('.accept');
        this.rejectButton = this.el.querySelector('.reject');
        this.init();
    }
    (0, $hvJJn._)(CookieBar, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                // if cookie consent has not been set, show the cookie bar
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($gBmLA))).get('june-cookie-consent')) {
                    this.el.classList.add('active');
                    // if the user accepts cookies, set the cookie and hide the cookie bar
                    this.acceptButton.addEventListener('click', function() {
                        (0, (/*@__PURE__*/$parcel$interopDefault($gBmLA))).set('june-cookie-consent', 'accept', {
                            expires: 365
                        });
                        document.body.classList.add('cookies-accepted');
                        _this.el.classList.remove('active');
                    });
                    // if the user rejects cookies, set the cookie to reject and hide the cookie bar
                    this.rejectButton.addEventListener('click', function() {
                        (0, (/*@__PURE__*/$parcel$interopDefault($gBmLA))).set('june-cookie-consent', 'reject', {
                            expires: 365
                        });
                        _this.el.classList.remove('active');
                    });
                }
            }
        }
    ]);
    return CookieBar;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=CookieBar.b338e7a0.js.map
